import Api from "./baseApi";

const state = {
  detail: {},
  all: [],
};

const actions = {
  getAll: async (context) => {
    let url = `/admin/Campaign/getAll`;
    let d = (await Api.get(url));
    context.commit("getAll", d);
    return d;
  },
  post: async (context, params) => {
    let url = `/admin/Campaign/add`;
    let d = (await Api.post(url, params));
    // eslint-disable-next-line no-console
    console.log("d :",d);
    return d;
  }, 
  update: async (context, params) => {
    let url = `/admin/Campaign/update`;
    let d = (await Api.put(url, params)).data;
    // eslint-disable-next-line no-console
    console.log("here",d);
    return d;
  },
  getById: async (context, id) => {
    let d = (await Api.get(`/admin/Campaign/get/${id}`)).data
    // eslint-disable-next-line no-console
    console.log("d :",d);
    context.commit("getById", d);
  },
  deleteById: async (context, id) => {
    let url = `/admin/Campaign/delete/${id}`;
    await Api.delete(url).data;
  },
};
const mutations = {
  getAll(state, settings) {
    state.all = settings;
  },
  getById(state, data) {
    state.detail = data
  }
};
export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
